import React from 'react';
import { Badge } from '../components/ui/badge';
import { Clock, CheckCircle2, XCircle, Gavel } from 'lucide-react';

export const StatusBadge = ({ status, size = 'default' }) => {
    const config = {
        pending: {
            variant: 'outline',
            className: 'status-pending border',
            icon: Clock,
            label: 'Pending'
        },
        approved: {
            variant: 'outline',
            className: 'status-approved border',
            icon: CheckCircle2,
            label: 'Approved'
        },
        rejected: {
            variant: 'outline',
            className: 'status-rejected border',
            icon: XCircle,
            label: 'Rejected'
        },
        appealed: {
            variant: 'outline',
            className: 'border border-info/40 bg-info/10 text-info',
            icon: Gavel,
            label: 'Appealed'
        }
    };

    const { variant, className, icon: Icon, label } = config[status] || config.pending;

    return (
        <Badge 
            variant={variant} 
            className={`${className} ${size === 'sm' ? 'text-xs py-0.5' : ''}`}
            data-testid={`status-badge-${status}`}
        >
            <Icon className={`${size === 'sm' ? 'w-3 h-3 mr-1' : 'w-3.5 h-3.5 mr-1.5'}`} />
            {label}
        </Badge>
    );
};

export const ViolationTypeBadge = ({ type }) => {
    const typeLabels = {
        signal_jump: 'Signal Jumping',
        wrong_side: 'Wrong Side',
        no_helmet: 'No Helmet',
        no_seatbelt: 'No Seatbelt',
        over_speed: 'Over Speeding',
        wrong_parking: 'Illegal Parking',
        lane_violation: 'Lane Violation',
        mobile_use: 'Mobile Usage',
        drunk_driving: 'Drunk Driving',
        overloading: 'Overloading',
        no_license: 'No License Plate',
        footpath_driving: 'Driving on Footpath',
        other: 'Other'
    };

    return (
        <Badge variant="secondary" data-testid={`violation-type-${type}`}>
            {typeLabels[type] || type}
        </Badge>
    );
};
